import { Container } from "./styles"
import { Page } from "../styles"
import IndexTable from "../../../components/IndexTable"
import { useState } from "react"
import RangedCalendar from "../../../components/RangedCalendar"
import { useUserContext } from "../../../components/contexts/useUserContext"

const RetailerReports = () => {

    const [dateRange, setDateRange] = useState(null)
    const { user } = useUserContext();
    
    return (
        <Page>
            <Container>
                <h5>Filtrar por Período</h5>
                <div className="filter">
                    <RangedCalendar onChange={setDateRange} value={dateRange}/>
                </div>
                <IndexTable
                    request='bookings/resold'
                    caption='Reservas efetuadas por seus convidados'
                    params={{retailer_id: user?.id, 
                            time_range: dateRange && dateRange[0] && dateRange[1] ?
                                [dateRange[0].getTime(), dateRange[1].getTime()] : null}}
                />
            </Container>
        </Page>
    )
}

export default RetailerReports
